import { Img } from '../../../../base/components/native/img'

export const AssistantClose = () => {

    const base = Img('/images/plus-icon.svg', {width: 32})

    base.cssClass({
        transform: 'rotate(-135deg)',
        backcgroundColor: '#fff',
        position: 'absolute',
        right: '30px',
        top: '20px',
        cursor: 'pointer',
        '@media (max-width: 768px)': {
            right: '10px',
            top: '10px',
        }
    })

    return base
}